import React from "react";
import Translate from '../../common/functions/translate';
import Button from "@material-ui/core/Button";
import ConfirmDialog from '../../common/components/confirmDialog/confirmDialog';
import Spinner from "../../common/components/spinner/spinner";
import Snackbar from "../../common/components/snackbar/snackbar";
import { connect } from 'react-redux';
import * as actionTypes from '../../store/actionTypes';
import { SelectButton } from 'primereact/selectbutton';
import LocalDataService from '../../services/localDataServices/localSynchronizationService';

interface IProps {
    onLangChange: any
}

interface IState {
    isLoading: boolean;
    currentLang: string;
    isVisibleConfirmDialog: boolean;
}

class SettingsComponent extends React.Component<IProps, IState>{
    snackbar: any;
    localDataService = new LocalDataService();

    constructor(props: IProps) {
        super(props);

        this.state = {
            isLoading: false,
            currentLang: 'bg',
            isVisibleConfirmDialog: false,
        }
    }

    componentDidMount() {
        let lang = localStorage.getItem('lang');

        if (!lang) {
            localStorage.setItem('lang', 'bg');
        } else {
            this.props.onLangChange(lang);
        }

        this.setState({
            currentLang: localStorage.getItem('lang') + ''
        })
    }

    handleChangeLang = (lang) => {
        if (lang) {
            localStorage.setItem('lang', lang);
            this.props.onLangChange(lang);
            this.setState({
                currentLang: lang
            })
        }
    }

    clearLocalData = () => {
        this.setState({ isVisibleConfirmDialog: false, isLoading: true });

        sessionStorage.removeItem('offerFilterData');

        this.localDataService.clearDatabase().then(
            () => {
                this.setState({ isLoading: false });

                localStorage.setItem('lastSyncDate', '');

                this.snackbar.show({ severity: 'success', summary: 'Локалните данни бяха изчистени успешно.' });
            })
            .catch(error => {
                this.setState({
                    isLoading: false,
                });
                this.snackbar.show({ severity: 'error', summary: Translate(error) });
                console.log(error);
            });

    }

    render() {
        const { isLoading, currentLang, isVisibleConfirmDialog } = this.state;
        const langs = [
            { label: 'BG', value: 'bg' },
            { label: 'EN', value: 'en' }
        ];

        return (
            <div className="app-page-content">

                <Snackbar ref={(el) => this.snackbar = el} />
                {isLoading ? <Spinner text={''} /> : null}

                <h1>{Translate("Settings")}</h1>

                <ul className="list-items">
                    <li>
                        <div className="item-info" style={{ flex: "60%" }}>
                            <div className="item-name">
                                {Translate('Language')}
                            </div>
                            <div className="item-desc">
                                {currentLang === 'bg' ? Translate('Bulgarian') : Translate('English')}
                            </div>
                        </div>
                        <div className="item-actions" style={{ flex: "40%", textAlign: 'right' }}>
                            <SelectButton style={{ minWidth: 100, marginRight: 10 }} value={currentLang} options={langs} onChange={(e) => this.handleChangeLang(e.value)} />
                        </div>
                    </li>
                    <li>
                        <div className="item-info" style={{ flex: "60%" }}>
                            <div className="item-name">
                                {Translate('Local data')}
                            </div>
                            <div className="item-desc">
                                {Translate('Clear local data')}
                            </div>
                        </div>
                        <div className="item-actions" style={{ flex: "40%", textAlign: "right" }}>
                            <Button className="action-button" variant="contained" color='primary' size='small' onClick={() => this.setState({ isVisibleConfirmDialog: true })}>
                                {Translate('Clear')}
                            </Button>
                        </div>
                    </li>

                </ul>

                {isVisibleConfirmDialog ?
                    <ConfirmDialog
                        headerTitle={Translate('Clear local data')}
                        isVisible={isVisibleConfirmDialog}
                        yesClick={this.clearLocalData}
                        noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
                        {Translate('Are you sure you want to clear local data')}
                    </ConfirmDialog>
                    : null}

            </div>
        );

    }
}

const mapDispatchToProps = dispatch => {
    return {
        onLangChange: (lang) => dispatch({ type: actionTypes.LANG_CHANGE, lang: lang })
    }
}

export default connect(null, mapDispatchToProps)(SettingsComponent);
